import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LinearProgress, Typography } from '@mui/material';
import { redirect } from '../lib/Utils';
import logout from './../lib/services/logout';
import useService from '../hooks/useService';
import UPPage from '../components/UPPage';

/**
 * Logout page
 */
export default function() {
  const { t } = useTranslation();
  const { isRequestDone, success, send } = useService(logout);

  useEffect(() => {
    send();
  }, [send]);

  useEffect(() => {
    if (isRequestDone && success) {
      redirect('/auth');
    }
  });

  if (!isRequestDone) {
    return <LinearProgress color="primary" />;
  }

  if (!success) {
    return (
      <UPPage>
        <Typography variant="body1" color="error">
          {t('errorLogout')}
        </Typography>
      </UPPage>
    );
  }
  return null;
}
